import { render, staticRenderFns } from "./u-file-input-underlined.vue?vue&type=template&id=18d079ed&scoped=true&"
import script from "./u-file-input-underlined.vue?vue&type=script&lang=js&"
export * from "./u-file-input-underlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d079ed",
  null
  
)

export default component.exports